// extracted by mini-css-extract-plugin
export var active = "Pagination_active__gB5Ok";
export var container = "Pagination_container__eBq0v";
export var disabled = "Pagination_disabled__rGDOo";
export var next = "Pagination_next__M6+Cp";
export var page = "Pagination_page__tCPyC";
export var paginationBreak = "Pagination_paginationBreak__l29f7";
export var previous = "Pagination_previous__nxI1N";